import { Component, DestroyRef, inject, Input, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { toolbarOptions } from "../../shared/model/toolbar-constants";
import { ListSearchResultsComponent } from "../../compound-components/search-display/search-results/list-result/list-search-results.component";
import { SearchSummaryPanelComponent } from "../../compound-components/search-display/search-summary-panel";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatIconModule } from "@angular/material/icon";
import { FeatureFlags } from "../../viewer-components/model/feature-flags";
import { FeatureFlagsService } from "../../viewer-components/services/internal-services/feature-flags.service";
import { ToolbarService } from "../../viewer-components/services/internal-services/toolbar.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { SearchPanelConfig } from "../../compound-components/model";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatDividerModule } from "@angular/material/divider";
import { SearchQueryService } from "../../compound-components/services/search";
import { MatIconButton } from "@angular/material/button";

@Component({
  selector: "app-search-enhanced-results-toolbar",
  imports: [
    CommonModule,
    ListSearchResultsComponent,
    SearchSummaryPanelComponent,
    MatTooltipModule,
    MatIconModule,
    MatToolbarModule,
    MatDividerModule,
    MatIconButton,
  ],
  standalone: true,
  templateUrl: "./search-enhanced-results.component.html",
  styleUrls: ["./search-enhanced-results.component.scss"],
})
export class SearchEnhancedResultsComponent implements OnInit {
  private destroyRef = inject(DestroyRef);

  private flagService = inject(FeatureFlagsService);

  private toolbarService = inject(ToolbarService);

  searchQueryService = inject(SearchQueryService);

  toolbarOption = toolbarOptions.SEARCH_ENHANCED_RESULTS;

  displayPanel = false;

  enabledFeature = false;

  /** Configuration for the search panel in toolbar mode */
  searchPanelConfig: SearchPanelConfig = {
    showExportButton: true,
    showSaveButton: true,
    showClearButton: true,
    customClasses: ["toolbar-search-panel"],
  };

  /** Forwarded to {@link SearchSummaryPanelComponent} to hide the detection button in 3D. */
  @Input() is3DMode = false;

  @Input() set enabledTool(tool: string) {
    this.displayPanel = this.toolbarOption === tool;
  }

  ngOnInit(): void {
    this.flagService
      .getFlags$()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((flags: Record<string, any>) => {
        this.enabledFeature = flags[FeatureFlags.ENHANCED_GEO_SEARCH] || false;
      });
  }

  togglePanelDisplay() {
    this.toolbarService.enableTool(!this.displayPanel ? this.toolbarOption : toolbarOptions.NONE);
  }
}
